// extracted by mini-css-extract-plugin
export default {"imagesContainer":"edit-images-modal_imagesContainer__VEbUi","buttonsContainer":"edit-images-modal_buttonsContainer__FDzUs"};